import os1 from "../assets/icons/os1.svg";
import os2 from "../assets/icons/os2.svg";
import os3 from "../assets/icons/os3.svg";
import heroExterior from "../assets/images/solutions/exteriorSolution.jpg";

/**
 * Single source for All Solutions cards and Solution Details page content.
 * Hero images: add per-solution assets later; interior/ceiling reuse exterior hero until provided.
 */
export const solutionsDetailList = [
  {
    slug: "exterior-system",
    heroTag: "EXTERIOR",
    title: "Exterior System",
    heroDescription:
      "Facade System Direct Fixing on Studs and Ventilated Façade System Installed in Front of the Building",
    cardDescription:
      "IRQGYP delivers advanced exterior solutions for durable, high-performance, weather-resistant architecture.",
    cardIcon: os1,
    heroImage: heroExterior,
    descriptionTabs: [
      "Facade System Direct Fixing on Studs",
      "Ventilated Façade System Installed in Front of the Building",
    ],
    descriptionBody:
      "Shieldex Board is a high-performance sheathing solution for exterior walls, mounted on IRQ C-Stud galvanized steel framing at 600 mm centers. It features a vapor barrier to manage moisture and ensure durability. The boards are fixed with anti-corrosion screws, reinforcing joints with a cementitious compound for a sealed surface. Additionally, Rockwool or mineral wool insulation improves energy efficiency and sound reduction within the wall cavity.",
  },
  {
    slug: "interior-drywall-system",
    heroTag: "INTERIOR",
    title: "Interior Drywall System",
    heroDescription:
      "Lightweight partitions with acoustic performance, moisture resistance, and integrated MEP routing.",
    cardDescription:
      "IRQGYP Drywall System: lightweight, acoustic, moisture-resistant walls with integrated services.",
    cardIcon: os2,
    heroImage: heroExterior,
    descriptionTabs: [
      "Partition and lining systems",
      "Acoustic and moisture-rated assemblies",
    ],
    descriptionBody:
      "IRQGYP interior drywall systems combine galvanized steel framing with high-performance gypsum boards for fast, clean installation. Boards are selected for fire resistance, sound reduction, and humidity exposure as required. Services integrate within the cavity with coordinated penetration detail, supporting modern fit-out schedules without compromising acoustic or fire strategy.",
  },
  {
    slug: "ceiling-system",
    heroTag: "CEILING",
    title: "Ceiling System",
    heroDescription:
      "Suspended and lay-in ceiling solutions engineered for performance, access, and visual finish.",
    cardDescription:
      "High-performance ceiling systems designed for durability and aesthetic integration.",
    cardIcon: os3,
    heroImage: heroExterior,
    descriptionTabs: [
      "Suspended metal framing",
      "Boards and acoustic finishes",
    ],
    descriptionBody:
      "Ceiling systems combine primary and secondary framing with gypsum or specialty boards to deliver level planes, acoustic control, and service access. Components are coordinated for load, deflection, and integration with lighting and HVAC, ensuring a durable ceiling line that matches architectural intent across commercial and residential spaces.",
  },
];

export function getSolutionDetailBySlug(slug) {
  if (!slug) return undefined;
  return solutionsDetailList.find((s) => s.slug === slug);
}
